import React from 'react';
import { useHistory } from 'react-router-dom';
import { ProtectedRoute } from '../../../Auth/ProtectedRoute/ProtectedRoute ';
import locationService from '../../services/location.service';
import InspectionLocationNative from './InspectionLocation.native';

const InspectionLocationContainer = (props: any) => {
  const history = useHistory();

  const goToInspection = () => {
    history.push('/inspection');
  };

  const shareLocation = () => {
    if (!locationService.isGeolocationAble()) {
      goToInspection();
      return;
    }
    locationService.getUserLocation(goToInspection, goToInspection);
  };

  const continueWithoutSharing = () => {
    goToInspection();
  };

  return (
    <ProtectedRoute>
      <InspectionLocationNative
        shareLocation={shareLocation}
        continueWithoutSharing={continueWithoutSharing}
      />
    </ProtectedRoute>
  );
};

export default InspectionLocationContainer;
